import Layout from "@/layout/Layout";
import React from "react";
import style from "@/pages/menu.scss";
import {useHistory} from "react-router";
import MButton from "@/components/atom/MButton";

const Term = () => {
  const history = useHistory()

  const toTerm = () => {
    history.push('/term')
  }
  const toCommercial = () => {
    history.push('/commercial')
  }
  const goBack = () => {
    history.push('/menu')
  }

  return (
    <>
      <div className="App">
        <Layout needTopBar={false}>
          <div className={style.buttons}>
            <button className={style.menuButton} type="button" onClick={toTerm}>ご利用規約</button>
            <button className={style.menuButton} type="button"
                    onClick={toCommercial}>特定商取引に関する法律に基づく表記
            </button>
            <button className={style.menuButton} type="button"
                    onClick={goBack}>戻る
            </button>
          </div>
        </Layout>
      </div>
    </>
  )

}

export default Term
